import AllowanceInputBlock from 'components/quoting/quotes/flat_allowances/AllowanceInputBlock'
import { type Allowance } from 'components/quoting/quotes/flat_allowances/FlatAllowanceExplorer'

type Props = {
  formIndex: number
  isLoading: boolean
  validateEmployeeAllowance?: (value: number, allowance: Allowance) => string | undefined
}

export default function DefaultAllowance ({
  formIndex,
  isLoading,
  validateEmployeeAllowance,
}: Props) {
  return (
    <AllowanceInputBlock
      label='Allowances'
      formIndex={formIndex}
      loading={isLoading}
      validateEmployeeAllowance={validateEmployeeAllowance}
    />
  )
}
